import React from "react";
import { BarChart3 } from "lucide-react";
import PnlChart from "../../common/PnlChart";
import './Dashboard.css';
import { useSelector } from "react-redux";

const PnlGraphCard = () => {
    const info = useSelector((state) => state.filter);
    const user = useSelector((state) => state.user);
  return (
    <div className="pnl-graph-card bg-card gradient-from-blue-500-to-cyan-500">
      <div className="pnl-graph-content">
        <div className="pnl-graph-header">
          <div className="pnl-graph-icon">
            <BarChart3 size={24} />
          </div>
          <h3 className="section-title">PNL Graph</h3>
        </div>
        <div className="pnl-graph-body">
          <PnlChart
            brokerId={info.brokerId}
            brokerName={info.brokerName}
            userId={user?.userID}
            showSummary={true}
            height={300}
            showControls={false}
            level={"user"}
          />
        </div>
      </div>
    </div>
  );
};

export default PnlGraphCard;
